import { render, staticRenderFns } from "./ShopLogin.vue?vue&type=template&id=53609478&"
import script from "./ShopLogin.vue?vue&type=script&lang=js&"
export * from "./ShopLogin.vue?vue&type=script&lang=js&"
import style0 from "./ShopLogin.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports